import { render, staticRenderFns } from "./GroupComponent.vue?vue&type=template&id=b4e58dfe&scoped=true"
import script from "./GroupComponent.vue?vue&type=script&lang=js"
export * from "./GroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e58dfe",
  null
  
)

export default component.exports